import { render } from "./PartOneOutput.vue?vue&type=template&id=59400b08&scoped=true"
const script = {}

import "./PartOneOutput.vue?vue&type=style&index=0&id=59400b08&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anupashyam\\Downloads\\gitlabs - rel path oops\\virtuallab-oop\\exp-9\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59400b08"]])

export default __exports__